import { HotjarConfigurationDisabled } from '@savgroup-front-common/core/components/HotjarProvider/HotjarProvider';

export default {
  enabled: false,
} as HotjarConfigurationDisabled;
